import { API } from 'aws-amplify'

import {
  createDgtPdOrderInspectionLog,
  generateFGInspectionForms,
  updateDgtPdOrderInspectionLog,
  getAverageFillingWeight
} from '../graphql/mutations'
import { format } from 'date-fns'
import { FGInspectionForm, FGInspectionSubmitResponse, FgInspectionStatus } from '../models'
import { OrderInspectionLog } from '../components/types'
import { FGInspectionTypes } from '../constants/EnumType'

export const generateFGInspectionForm = async (
  orderId: string,
  formType: string, 
  materialCode: string,
  materialName: string,
  productProfile: string,
  lineNo: string,
  lineDesc: string,
  standardFillingWeight: string,
  startRecordDate: Date,
  bulkCode: string,
  bulkDesc: string,
) : Promise<FGInspectionForm> => {
  const postPayload = {
    query: generateFGInspectionForms,
    variables: {
      pd_order: orderId, 
      form_type: formType,
      material_code: materialCode,
      material_name: materialName, 
      date: format(startRecordDate, 'dd.MM.yyyy'),
      product_profile: productProfile,
      line_no: lineNo,
      line_desc: lineDesc,
      std_fwt: standardFillingWeight,
      bulk_code: bulkCode,
      bulk_description: bulkDesc
    }
  }
  const postResult: any = await API.graphql(postPayload)
  const response : FGInspectionForm = postResult.data?.generateFGInspectionForms
  return response
}

export const createInspectionLog = async (
  productionOrderId: string,
  workCenterId: string,
  workCenterDesc: string,
  inspectionType: FGInspectionTypes,
  formName: string,
  formUrl: string,
  username: string,
) : Promise<OrderInspectionLog> => {
  const postResult : any = await API.graphql({
    query: createDgtPdOrderInspectionLog,
    variables: { input: {
      productionOrderId,
      workCenterId,
      workCenterDescription: workCenterDesc,
      inspectionType,
      formName,
      formUrl,
      createdBy: username,
      createdVersion: 'c9ed51c'
    }}
  })
  return postResult.data.createDgtPdOrderInspectionLog
}

export const getAverageFillingWeightApi = async (
  orderId: string,
  lineNo: string,
) : Promise<FGInspectionSubmitResponse> => {
  const postPayload = {
    query: getAverageFillingWeight,
    variables: {
      pd_order: orderId, 
      form_type: 'pd_filling',
      line_no: lineNo
    }
  }
  const postResult: any = await API.graphql(postPayload)
  const response : FGInspectionSubmitResponse = postResult.data?.getAverageFillingWeight
  return response
}

export const submitInspectionLog = async (
  inspectionLogId: string,
  version: number,
  username: string,
  avgFwtWeight?: FGInspectionSubmitResponse
) : Promise<OrderInspectionLog> => {
  const postResult : any = await API.graphql({
    query: updateDgtPdOrderInspectionLog,
    variables: { input: {
      id: inspectionLogId,
      _version: version,
      inspectionStatus: FgInspectionStatus.SUBMITTED,
      avgFwtByLots: JSON.stringify(avgFwtWeight?.avgFwtByLots),
      submittedDatetime: Math.floor(Date.now() / 1000),
      submittedBy: username,
      updatedBy: username,
      updatedVersion: 'c9ed51c'
    }}
  })
  return postResult.data.updateDgtPdOrderInspectionLog
}

export const reworkInspectionLog = async (
  inspectionLogId: string,
  version: number,
  username: string,
) : Promise<OrderInspectionLog> => {
  const postResult : any = await API.graphql({
    query: updateDgtPdOrderInspectionLog,
    variables: { input: {
      id: inspectionLogId,
      _version: version,
      inspectionStatus: FgInspectionStatus.TESTING,
      avgFwtByLots: null,
      submittedDatetime: null,
      submittedBy: null,
      updatedBy: username,
      updatedVersion: 'c9ed51c'
    }}
  })
  return postResult.data.updateDgtPdOrderInspectionLog
}
  
export const updateFwt = async (
  inspectionLogId: string,
  version: number,
  username: string,
  avgFwtWeight?: FGInspectionSubmitResponse
) : Promise<OrderInspectionLog> => {
  const postResult : any = await API.graphql({
    query: updateDgtPdOrderInspectionLog,
    variables: { input: {
      id: inspectionLogId,
      _version: version,
      avgFwtByLots: JSON.stringify(avgFwtWeight?.avgFwtByLots),
      updatedBy: username,
      updatedVersion: 'c9ed51c'
    }}
  })
  return postResult.data.updateDgtPdOrderInspectionLog
}